import $ from "jquery";
import isEqual from "lodash/isEqual";
import reverse from "lodash/reverse";
import Glider from "glider-js";
import queryString from "query-string";
import { checkEndcap } from "./event-sliders.js";
import { isValidURL } from "./helpers.js";
import { Toast, ToastContainer } from "./toast-components";

$(() => {
  // escape hatch - only pop announcements on logged-in pages
  if (!WP.uid) return;

  // setup
  const defaultLifespan = 15 * 1000;
  const database = firebase.database();
  const announcements = database.ref(`${WP.envKey}/announcements`);
  let prevAnnouncements = false;
  const userSegments = WP.segments;

  // HTML elements
  const sliderPresent =
    document.querySelector(".event-section-announcements") !== null;

  if (sliderPresent) {
    var section = document.querySelector(".event-section-announcements");
    var slider = section.querySelector(".announcement-list");
    var sliderNav = section.querySelector(".announcement-nav");
    var sliderNavPrev = sliderNav.querySelector(".prev-arrow");
    var sliderNavNext = sliderNav.querySelector(".next-arrow");
  }

  // autorun
  announcements.on("value", function (snapshot) {
    // format and filter out extraneous data
    const data = Object.entries(snapshot.val() || {})
      .map(([k, v]) => ({ ...v, guid: k }))
      .filter((node) => node.status === true && node.destination?.length)
      .filter((node) => node.destination.includes(parseInt(WP.pageID)))
      .filter((node) => {
        // include if annoucement_restrict_segments is either false OR undefined
        if (!node.restrict_segment) {
          return true;
          // also include if current user is in specified segments
        } else if (node.restrict_segment && Array.isArray(node.segments)) {
          if (node.segments.some((segId) => userSegments.includes(segId))) {
            return true;
          }
        }
      });

    // FIRST FB READ: initialize DOM and slick slider
    // * or popping one from zero
    if (
      sliderPresent &&
      (prevAnnouncements === false ||
        (Array.isArray(prevAnnouncements) && prevAnnouncements.length === 0))
    ) {
      reverse(data);
      let markup = "",
        i = 0;
      data.forEach((node) => {
        i++;

        // basic setup
        const text = node.text,
          img = node.image,
          guid = node.guid;
        let type = node.link_type,
          target = "",
          link = "",
          link_class = "announcement-list-link";

        if (type === "room") {
          link = node.link_room;
          if (node.link_query_and_anchor) link += node.link_query_and_anchor;
        } else if (type === "ext") {
          link = node.link_ext;
          target = "_blank";
        }

        // clip links on this page
        if (isValidURL(link)) {
          const linkURL = new URL(link);
          if (linkURL.pathname === location.pathname && linkURL.search) {
            const { c } = queryString.parse(linkURL.search);
            if (c) {
              type = "clip";
              node.link_clip = c;
              link_class += " js-hero-swap";
            }
          }
        }

        // specialty
        if (node.link_pause_video) {
          link_class += " pause-video";
        }

        markup += `
          <div class="announcement-list-item card">
            <a
              class="${link_class}"
              href="${link}"
              target="${target}"
              data-guid="${guid}"
              ${type === "clip" ? `data-clip-id="${node.link_clip}"` : ""}
            >
              ${
                img
                  ? `<span class="announcement-list-icon"><img src="${img}" /></span>`
                  : ""
              }
              <span class="announcement-list-text">${text}</span>
              <span class="announcement-list-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.51182 20.4894L3.51182 20.4894C8.20044 25.178 15.8022 25.178 20.4908 20.4894C25.1795 15.8008 25.1795 8.19901 20.4909 3.51041C15.8023 -1.17824 8.20047 -1.17826 3.51187 3.51036C3.51186 3.51037 3.51184 3.51039 3.51183 3.5104C-1.17071 8.20154 -1.17071 15.7983 3.51182 20.4894L3.51182 20.4894ZM11.3678 9.47036L7.85783 9.31936C7.30164 9.28886 6.86436 8.83234 6.85783 8.27536L6.85783 7.85636L6.85783 7.85638C6.85829 7.31348 7.29876 6.87375 7.84166 6.87421C7.84704 6.87421 7.85242 6.87426 7.8578 6.87436L15.9478 7.02636C16.5048 7.0433 16.9535 7.48856 16.9748 8.04536L17.1918 16.0654L17.1918 16.0654C17.2073 16.602 16.7848 17.0495 16.2482 17.065C16.2381 17.0652 16.2279 17.0654 16.2178 17.0654L15.8008 17.0654C15.242 17.0583 14.7823 16.623 14.7448 16.0654L14.5508 12.6174C14.5208 12.0674 14.1768 11.9364 13.7878 12.3254L9.18782 16.9254C8.79752 17.3161 8.16436 17.3165 7.77362 16.9261C7.77335 16.9259 7.77309 16.9256 7.77283 16.9254L7.07283 16.2254C6.68209 15.8351 6.68174 15.2019 7.07204 14.8111C7.0723 14.8109 7.07257 14.8106 7.07283 14.8104L11.6618 10.2244C12.0488 9.83236 11.9168 9.49436 11.3678 9.47036L11.3678 9.47036Z" fill="currentColor"/>
                </svg>
              </span>
            </a>
          </div>
        `;

        if (i === data.length) {
          // DOM
          document.querySelector(".announcement-list").innerHTML = markup;

          // load slider
          const glider = new Glider(slider, {
            slidesToShow: "auto",
            slidesToScroll: "auto",
            arrows: {
              prev: sliderNavPrev,
              next: sliderNavNext,
            },
            itemWidth: 350,
            exactWidth: false,
            duration: 1,
            responsive: [
              {
                breakpoint: 520,
                settings: {
                  itemWidth: 516,
                  exactWidth: true,
                },
              },
            ],
          });

          // check endcap once loaded
          glider.ele.addEventListener("glider-refresh", function () {
            bodhisvgsInlineSupport(); // * inline svgs
            checkEndcap(this);
          });

          glider.refresh();
        }
      });
    }

    // ALL SUBSEQUENT FB READS: pop/mutate/destroy
    if (prevAnnouncements !== false) {
      // Array of updated announcements
      const mutateAnnouncements = data
        .filter(
          (node) =>
            prevAnnouncements.some(({ guid }) => node.guid === guid) &&
            !isEqual(
              node,
              prevAnnouncements.find(({ guid }) => node.guid === guid)
            )
        )
        .map((node) => ({ ...node, mutated: true }));

      // Array of new announcements
      const pushAnnouncements = data.filter(
        ({ guid }) => !prevAnnouncements.some((node) => node.guid === guid)
      );

      // Array of removed announcements
      const destroyAnnouncements = prevAnnouncements.filter(
        ({ guid }) => !data.some((node) => node.guid === guid)
      );

      // define destroy actions
      function destroy() {
        if (destroyAnnouncements.length && sliderPresent) {
          // load glider
          const glider = Glider(slider);

          // get glider indexes to 🔪
          let killSet = [];
          destroyAnnouncements.forEach(({ guid }, i) => {
            const $el = $(`[data-guid="${guid}"]`);
            if ($el.length) {
              const killIndex = $el.closest(".glider-slide").data("gslide");
              killSet.push(killIndex);
            }

            // sort from highest to lowest before 🔪
            // ...to preserve indices when 🔪
            if (i === destroyAnnouncements.length - 1) {
              killSet
                .sort((a, b) => b - a)
                .forEach((i) => glider.removeItem(i));
            }
          });

          // refresh glider
          glider.refresh();

          // check the endcap
          checkEndcap(slider);
        }
      }

      // define mutate actions
      function mutate() {
        if (mutateAnnouncements.length) {
          mutateAnnouncements.forEach((node) => {
            // setup
            const text = node.text,
              img = node.image,
              guid = node.guid;
            let type = node.link_type,
              target = "",
              link = "";

            if (type === "ext") {
              link = node.link_ext;
              target = "_blank";
            } else if (type === "room") {
              link = node.link_room;
              if (node.link_query_and_anchor)
                link += node.link_query_and_anchor;
            }

            // clip links on this page
            if (isValidURL(link)) {
              const linkURL = new URL(link);
              if (linkURL.pathname === location.pathname && linkURL.search) {
                const { c } = queryString.parse(linkURL.search);
                if (c) {
                  type = "clip";
                  node.link_clip = c;
                }
              }
            }

            const $el = $(`[data-guid="${guid}"]`).closest(".glider-slide");

            // update element
            const pageMarkup = `
                  <a
              ${
                type === "clip"
                  ? 'class="announcement-list-link js-hero-swap"'
                  : 'class="announcement-list-link"'
              }
              href="${link}"
              target="${target}"
              data-guid="${guid}"
              ${type === "clip" ? `data-clip-id="${node.link_clip}"` : ""}
                  >
                    ${
                      img
                        ? `<span class="announcement-list-icon"><img src="${img}" /></span>`
                        : ""
                    }
                    <span class="announcement-list-text">${text}</span>
                    <span class="announcement-list-arrow">
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="13" cy="13" r="12.25" stroke="white" stroke-width="1.5"></circle>
                        <path d="M8.90433 8.19051C8.71494 8.19051 8.5333 8.26575 8.39938 8.39967C8.26546 8.53359 8.19023 8.71522 8.19023 8.90461C8.19023 9.094 8.26546 9.27564 8.39938 9.40956C8.5333 9.54348 8.71494 9.61871 8.90433 9.61871L14.5029 9.61871C14.5264 9.61877 14.5494 9.62579 14.5689 9.6389C14.5885 9.65201 14.6037 9.67062 14.6126 9.69238C14.6216 9.71413 14.6239 9.73805 14.6193 9.76112C14.6147 9.7842 14.6033 9.80538 14.5867 9.82199L8.39827 16.017C8.26443 16.1511 8.18932 16.3328 8.18945 16.5222C8.18959 16.7116 8.26496 16.8932 8.39898 17.027C8.53301 17.1609 8.71471 17.236 8.90412 17.2358C9.09353 17.2357 9.27512 17.1603 9.40896 17.0263L15.605 10.8236C15.6216 10.807 15.6428 10.7956 15.666 10.791C15.6891 10.7864 15.713 10.7887 15.7348 10.7977C15.7566 10.8068 15.7752 10.8221 15.7883 10.8417C15.8013 10.8613 15.8083 10.8843 15.8082 10.9079L15.8082 16.5217C15.8082 16.7111 15.8835 16.8927 16.0174 17.0266C16.1513 17.1605 16.333 17.2358 16.5223 17.2358C16.7117 17.2358 16.8934 17.1605 17.0273 17.0266C17.1612 16.8927 17.2364 16.7111 17.2364 16.5217V9.38068C17.2364 9.22431 17.2056 9.06946 17.1458 8.925C17.0859 8.78054 16.9981 8.6493 16.8875 8.53877C16.7769 8.42824 16.6456 8.34059 16.5011 8.28084C16.3566 8.22108 16.2017 8.19039 16.0453 8.19051L8.90433 8.19051Z" fill="white"></path>
                      </svg>
                    </span>
                  </a>
              `;

            $el.html(pageMarkup);

            // covert SVG images to inline for branding colors
            bodhisvgsInlineSupport();

            // refresh glider
            const glider = Glider(slider);
            glider.refresh();

            // check endcap
            checkEndcap(slider);
          });
        }
      }

      // define push actions
      function push() {
        if (pushAnnouncements.length) {
          let lifespan = defaultLifespan;
          let Toasts = [];
          pushAnnouncements.forEach((node) => {
            // setup
            const text = node.text,
              img = node.image,
              guid = node.guid,
              duration = node.duration,
              skipPop = node.mutated,
              redirect = node.link_redirect || false;
            let type = node.link_type,
              target = "",
              link = "";

            if (type === "ext") {
              link = node.link_ext;
              target = "_blank";
            } else if (type === "room") {
              link = node.link_room;
              if (node.link_query_and_anchor)
                link += node.link_query_and_anchor;
            }

            // clip links on this page
            if (isValidURL(link)) {
              const linkURL = new URL(link);
              if (linkURL.pathname === location.pathname && linkURL.search) {
                const { c } = queryString.parse(linkURL.search);
                if (c) {
                  type = "clip";
                  node.link_clip = c;
                }
              }
            }

            // check specific lifespan
            if (parseInt(duration) && parseInt(duration) * 1000 !== lifespan) {
              lifespan = parseInt(duration) * 1000;
            }

            // check if item is already in glider
            let existingEl = document.querySelector(
              `.announcement-list-link[data-guid="${guid}"]`
            );

            if (existingEl) {
              // add "card--new" class
              existingEl.parentElement.classList.add("card--new");
            } else {
              if (sliderPresent) {
                // clear "new" class off any existing
                const existingItems = Array.from(
                  document.querySelectorAll(".announcement-list-item.card--new")
                );

                existingItems.forEach((domNode) =>
                  domNode.classList.remove("card--new")
                );

                // add to page body carousel
                const expiryId = new Date().getTime();
                const newSlide = document.createElement("div");
                newSlide.classList.add(
                  "announcement-list-item",
                  "card",
                  "card--new"
                );
                newSlide.dataset.expiry = expiryId;
                newSlide.innerHTML = `
                    <a
                  ${
                    type === "clip"
                      ? 'class="announcement-list-link js-hero-swap"'
                      : 'class="announcement-list-link"'
                  }
                  href="${link}"
                  target="${target}"
                  data-guid="${guid}"
                  ${type === "clip" ? `data-clip-id="${node.link_clip}"` : ""}
                    >
                      ${
                        img
                          ? `<span class="announcement-list-icon"><img src="${img}" /></span>`
                          : ""
                      }
                      <span class="announcement-list-text">${text}</span>
                      <span class="announcement-list-arrow">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.51182 20.4894L3.51182 20.4894C8.20044 25.178 15.8022 25.178 20.4908 20.4894C25.1795 15.8008 25.1795 8.19901 20.4909 3.51041C15.8023 -1.17824 8.20047 -1.17826 3.51187 3.51036C3.51186 3.51037 3.51184 3.51039 3.51183 3.5104C-1.17071 8.20154 -1.17071 15.7983 3.51182 20.4894L3.51182 20.4894ZM11.3678 9.47036L7.85783 9.31936C7.30164 9.28886 6.86436 8.83234 6.85783 8.27536L6.85783 7.85636L6.85783 7.85638C6.85829 7.31348 7.29876 6.87375 7.84166 6.87421C7.84704 6.87421 7.85242 6.87426 7.8578 6.87436L15.9478 7.02636C16.5048 7.0433 16.9535 7.48856 16.9748 8.04536L17.1918 16.0654L17.1918 16.0654C17.2073 16.602 16.7848 17.0495 16.2482 17.065C16.2381 17.0652 16.2279 17.0654 16.2178 17.0654L15.8008 17.0654C15.242 17.0583 14.7823 16.623 14.7448 16.0654L14.5508 12.6174C14.5208 12.0674 14.1768 11.9364 13.7878 12.3254L9.18782 16.9254C8.79752 17.3161 8.16436 17.3165 7.77362 16.9261C7.77335 16.9259 7.77309 16.9256 7.77283 16.9254L7.07283 16.2254C6.68209 15.8351 6.68174 15.2019 7.07204 14.8111C7.0723 14.8109 7.07257 14.8106 7.07283 14.8104L11.6618 10.2244C12.0488 9.83236 11.9168 9.49436 11.3678 9.47036L11.3678 9.47036Z" fill="currentColor"/>
                        </svg>
                      </span>
                    </a>
                  `;

                let sliderTrack = slider.querySelector(".glider-track"),
                  glider = Glider(slider);

                // add slide to DOM
                if (prevAnnouncements.length) {
                  sliderTrack.insertBefore(newSlide, sliderTrack.childNodes[0]);
                } else {
                  glider.addItem(newSlide);
                }

                // refresh glider & scroll to first element
                glider.refresh();
                glider.scrollItem(0);

                // check endcap
                checkEndcap(slider);

                // set countdown to expire newness
                setTimeout(() => {
                  const expiringAnnouncement = document.querySelector(
                    `[data-expiry-id="${expiryId}"]`
                  );

                  if (expiringAnnouncement)
                    expiringAnnouncement.classList.remove("card--new");
                }, 300000);
              }
            }

            // stage each toast in array to pop in ToastContainer,
            // ... excepting 'mutated' announcements (existing announcements with edits on them)
            if (!skipPop) {
              Toasts.push(Toast({ text, img, link, target, redirect }));

              // process redirects
              if (redirect) {
                // increase lifespan by random millisecond value from 0 to 5s
                lifespan = lifespan + Math.floor(Math.random() * 5000);
                let remaining = lifespan - (lifespan % 1000);
                const tick = setInterval(() => {
                  remaining += -1000;
                  const counter = document.querySelector(".redirect-counter");
                  if (counter) counter.innerHTML = remaining / 1000;
                }, 1000);
                setTimeout(() => {
                  clearInterval(tick);
                  location.assign(link);
                }, lifespan);
              }
            }
          });

          // Pop ToastContainer
          ToastContainer(Toasts, lifespan);
        }
      }

      // destroy first, then add
      if (sliderPresent) {
        $.when(mutate(), destroy()).then(function () {
          push();
        });
      } else {
        push();
      }

      // Have we no announcements left?
      const isEmpty = data.length === 0;
      if (isEmpty && sliderPresent)
        Glider(document.querySelector(".announcement-list")).destroy();
    }

    // reset for next autorun
    prevAnnouncements = data;
  });
});
